/**
 * DataAuditWarning.tsx — PPP Stream D, DLD §D3
 *
 * Amber ribbon displayed at the top of EntityDetail when the backend
 * reports one or more data integrity gaps in entity.dataIntegrityGaps[].
 *
 * Returns null when gaps is empty — callers do not need to guard.
 */

import { AlertTriangle } from "lucide-react";

interface DataAuditWarningProps {
  gaps: string[];
}

export function DataAuditWarning({ gaps }: DataAuditWarningProps): JSX.Element | null {
  if (!gaps.length) return null;

  return (
    <div
      className="rounded-[11px] border border-[#fde9c8] bg-amber-soft px-4 py-3 mb-4 flex items-start gap-3"
      role="alert"
      data-testid="data-audit-warning"
    >
      <AlertTriangle className="h-4 w-4 text-amber shrink-0 mt-0.5" aria-hidden />
      <div>
        <p className="text-[13px] font-semibold text-amber-text">
          {gaps.length} data gap{gaps.length > 1 ? "s" : ""} detected in this entity
        </p>
        <ul className="mt-1 text-[12px] text-amber-text/80 space-y-0.5">
          {gaps.slice(0, 3).map((g, i) => (
            <li key={i}>{g}</li>
          ))}
          {gaps.length > 3 && (
            <li>…and {gaps.length - 3} more. See audit report.</li>
          )}
        </ul>
      </div>
    </div>
  );
}
